module.exports = __webpack_public_path__ + "img/export_excel.svg";